export default __webpack_public_path__ + "static/sz_en_5-11ce709186e7ccc8a46c86cfea281c6c.mp4";